// @flow

import React, { useState } from 'react';

import { useTheme } from '@mui/material/styles';
import { log } from '../utils/jsUtils';

import IconButton from '@mui/material/IconButton';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';

import MenuIcon from '@mui/icons-material/Menu';

import UserProfileMenu from './UserProfileMenu';
import Skeleton from '@mui/material/Skeleton';

// import styles from './Feed/Styles/MemberHeader.Style';

import memberHeaderStyles from './Feed/Styles/MemberHeader.Style';

type Props = {
  mobileOpen?: bool,
  isOnboading?: bool, // user is still onboarding, limit options.
  usehandleDrawerToggle?: Function,
  children: Object,
  isLoading?: bool
};

const HeaderTopBar = (props: Props) => {
  const {
    children,
    usehandleDrawerToggle,
    isOnboading,
    isLoading = false
  } = props;
  const theme = useTheme();
  return (
    <Grid
      item
      sx={{
        ...memberHeaderStyles.rowSub(theme),
        ...memberHeaderStyles.topBar(theme)
      }}
    >
      {usehandleDrawerToggle && (
          <IconButton
            aria-label="Open drawer"
            color="inherit"
            onClick={usehandleDrawerToggle}
            disabled={isLoading}
            sx={{
              ...memberHeaderStyles.menuButton(theme)
            }}
              // color: 'white',
              // textShadow: '0px 0 4px hsl(0deg 0% 0% / 12%)',
              // width: '1.2rem',
              // marginRight: theme.spacing(1),
              // marginTop: theme.spacing(0.5),
              // height: 50,
              // width: 50,
              // [theme.breakpoints.up('sm')]: {
              //   display: 'none',
              // },
            // }}
          >
            <MenuIcon />
          </IconButton>
      )}
      <Grid item>{children}</Grid>
      <Box style={{ flexGrow: 1 }} />
      {isLoading ? (
        <Skeleton variant="circular" width={40} height={40} sx={{ bgcolor: 'rgba(255,255,255,0.2)' }} />
      ) : (
        <UserProfileMenu isOnboading={isOnboading} />
      )}
    </Grid>
  );
};

export default HeaderTopBar;
